module.exports = __webpack_public_path__ + "static/media/video-cover.c91024df.jpg";